import React from 'react';
import Loadable from 'react-loadable';

import './style';

const loadable = (loader, loading = () => null) => Loadable({ loader, loading });
const WeaSystemSetting = loadable(() => import('./WeaSystemSetting'));

class Index extends React.Component {
  constructor(props) {
    super(props);
    const { location = {}, visible = false } = props;
    const { query = {} } = location;
    const { display = '' } = query;
    this.state = { display, visible };
  }

  render() {
    const { display, visible } = this.state;
	const { callbackFn={} } = this.props;
    return display == 'page' || visible ? <WeaSystemSetting ecId={`${this && this.props && this.props.ecId || ''}_WeaSystemSetting@9etnma`} {...this.props} display={display} visible={visible} onShow={this.onShow} callbackFn={callbackFn}/> : null;
  }

  onShow = (visible = true) => {
    this.setState({ visible });
  };

  onHide = () => {
    this.setState({ visible: false });
  };
}

export default Index;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-system-setting/index.js